<template>
  <v-container>
    <br>
    <div class="text-center">
      <h2 class="black--text">Solicitud de vacaciones</h2>
      <h4 class="grey--text text--darken-1 mb-4">
        Solicita el periodo para tus vacaciones
      </h4>
    </div>

    <v-card v-if="!loading" class="mx-auto my-4 pa-4" max-width="900">

      <v-row dense>
        <v-col cols="auto" class="mx-auto">
          <img :src="logoUrl" style="max-height:60px" />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="auto" class="mx-auto">
          <p>Hola, <b>{{ perNombre }}</b></p>
        </v-col>
      </v-row>

      <v-progress-linear v-if="loading" indeterminate color="primary" class="my-4" />

      <v-col cols="12">
        <v-alert type="info" outlined dense class="mt-1">
          Este es el cuestionario para la solicitud de tus vacaciones. Para ello deberás
          decirnos cuánto tiempo llevas con nosotros y seleccionar tu jornada laboral.
          A continuación aparecerán tus periodos vacacionales anuales, por favor, elige tanto primera como segunda opción en las semanas que prefieras. 
          Todos los campos son obligatorios. ¿Quieres que
          sepamos algo más? Usa la sección de observaciones si lo necesitas.
        </v-alert>
      </v-col>

      <!-- Antigüedad -->
      <div class="ml-2 mb-2 font-weight-bold">¿Cuánto tiempo llevas con nosotros?</div>
      <v-radio-group class='ml-2' v-model="respuesta.antiguedad" row>
        <v-radio label="Más de un año" value="SI" />
        <v-radio label="Menos de un año" value="NO" />
      </v-radio-group>

      <!-- Selección de jornada -->
      <div class="ml-2 mb-2 font-weight-bold">¿Qué jornada laboral tienes?</div>
      <v-col cols="5">
        <v-select :items="jornadas" item-text="name" item-value="id" v-model="respuesta.jornada" label="jornada"
          prepend-icon="mdi-calendar-account" :rules="[v => !!v || 'Requerido']" clearable @change="onjornadaChange" />
      </v-col>

      <!-- Selección de Vacaciones -->
      <div v-if="periodosjornada.length > 0" class="mt-4">
        <div class="ml-2 mb-2 font-weight-bold">
          Selecciona tus opciones de vacaciones por periodo
        </div>

        <v-row v-for="periodo in periodos" :key="periodo" class="mb-3">
          <!-- Primera opción -->
          <v-col cols="5">
            <v-select :items="(intervalosjornada[periodo] || []).map(item => ({ value: item, text: toLabel(item) }))"
              v-model="respuesta.periodos[periodo].vacacion1" :label="`${periodo} - Primera opción`"
              prepend-icon="mdi-beach" :rules="[v => !!v || 'Requerido']" clearable
              @change="onPrimeraOpcionChange(periodo)" />
          </v-col>

          <!-- Segunda opción -->
          <v-col cols="5" v-if="respuesta.periodos[periodo].mostrarSegundaOpcion">
            <v-select :items="(intervalosjornada[periodo] || [])
              .filter(i => i !== respuesta.periodos[periodo].vacacion1)
              .map(item => ({ value: item, text: toLabel(item) }))" v-model="respuesta.periodos[periodo].vacacion2"
              :label="`Segunda opción (${periodo})`" prepend-icon="mdi-beach" :rules="[v => !!v || 'Requerido']"
              clearable />
          </v-col>
        </v-row>
      </div>

      <!-- Observaciones -->
      <v-row class="mt-4">
        <v-col cols="12">
          <div class="mb-2 font-weight-bold">Observaciones</div>
          <v-textarea v-model="observaciones" outlined rows="3" auto-grow
            label="Escribe aquí cualquier información adicional (opcional)" />
        </v-col>
      </v-row>

      <v-divider class="my-4" />
      <v-row class="mt-4 justify-end">
        <v-col cols="auto">
          <v-btn color="primary" large class="d-flex align-center" :loading="loading" @click="onClickSaveData">
            <v-icon left>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

  </v-container>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";


const intervalosGrupos = {
  grupoA: { // jornada jornada completa y apoyo(parical)
    "INV1": [
      "2026-01-19_2026-01-25", "2026-01-26_2026-02-01", "2026-02-02_2026-02-08", "2026-02-09_2026-02-15",
      "2026-02-16_2026-02-22", "2026-02-23_2026-03-01", "2026-03-02_2026-03-08", "2026-03-09_2026-03-15",
      "2026-03-16_2026-03-22", "2026-03-23_2026-03-29", "2026-04-06_2026-04-12", "2026-04-13_2026-04-19",
      "2026-04-20_2026-04-26", "2026-04-27_2026-05-03", "2026-05-04_2026-05-10", "2026-05-11_2026-05-17",
      "2026-05-18_2026-05-24", "2026-05-25_2026-05-31", "2026-06-01_2026-06-07", "2026-06-08_2026-06-14"
    ],
    "VERANO": [
      "2026-06-15_2026-06-28", "2026-06-29_2026-07-12", "2026-07-13_2026-07-26",
      "2026-07-27_2026-08-09", "2026-08-10_2026-08-23", "2026-08-24_2026-09-06", "2026-09-07_2026-09-20"
    ],
    "INV2": [
      "2026-09-21_2026-09-27", "2026-09-28_2026-10-04", "2026-10-05_2026-10-11",
      "2026-10-19_2026-10-25", "2026-10-26_2026-11-01", "2026-11-02_2026-11-08",
      "2026-11-09_2026-11-15", "2026-11-16_2026-11-22", "2026-12-07_2026-12-13"
    ]
  },
  grupoB: { // jornada 1FS y 2FS
    "INV1": [
    "2026-01-18_2026-01-31", "2026-02-01_2026-02-14", "2026-02-15_2026-02-28", "2026-03-01_2026-03-14",
    "2026-03-15_2026-03-28", "2026-04-12_2026-04-25", "2026-04-26_2026-05-09", "2026-05-10_2026-05-23",
    "2026-05-24_2026-06-06" /* intervalos INV1 */
    ],

    "VERANO": [
      "2026-06-07_2026-06-20", "2026-06-21_2026-07-04", "2026-07-05_2026-07-18", "2026-07-19_2026-08-01",
      "2026-08-02_2026-08-15", "2026-08-16_2026-08-29", "2026-08-30_2026-09-12" /* intervalos VERANO */
    ],

    "INV2": [
      "2026-09-13_2026-09-19", "2026-09-20_2026-09-26", "2026-09-27_2026-10-03", "2026-10-25_2026-10-31",
      "2026-11-01_2026-11-07", "2026-11-08_2026-11-14", "2026-11-15_2026-11-21", "2026-12-13_2026-12-19" /* intervalos INV2 */
    ]
  },
  grupoC: { 
    "INV1": [
      "2026-01-17_2026-01-30", "2026-01-31_2026-02-13", "2026-02-14_2026-02-27", "2026-02-28_2026-03-13",
      "2026-03-14_2026-03-27", "2026-04-11_2026-04-24", "2026-04-25_2026-05-08", "2026-05-09_2026-05-22",
      "2026-05-23_2026-06-05"
    ],
  
    "VERANO": [
      "2026-06-06_2026-06-19", "2026-06-20_2026-07-03", "2026-07-04_2026-07-17", "2026-07-18_2026-07-31",
      "2026-08-01_2026-08-14", "2026-08-15_2026-08-28", "2026-08-29_2026-09-11"
    ],
  
    "INV2": [
      "2026-09-12_2026-09-18", "2026-09-19_2026-09-25", "2026-09-26_2026-10-02", "2026-10-24_2026-10-30",
      "2026-10-31_2026-11-06", "2026-11-07_2026-11-13", "2026-11-14_2026-11-20", "2026-12-12_2026-12-18"
    ]
  }
};


export default {
  name: "SolicitudVacaciones",
  computed: {
    ...mapState(['empId', 'perId', 'perAux', 'esEmpleado', 'urlRaiz', 'per']),

    perNombre() {
      return this.per && this.per.PerNom ? this.per.PerNom : "empleado/a";
    },
  },

  data: () => ({
    logoUrl: "https://www.martinmartin.es/wp-content/uploads/2025/08/logo-16x16-1.png",
    loading: false,
    observaciones: "",

    cuestionario: {
      descripcion: '',
      PreguntasCuestionario: [],
      Respuestas: []
    },
    periodosjornada: ["INV1", "VERANO", "INV2"],
    periodos: [],

    respuesta: {
      respuesta: { jornada: null, periodos: {} },
      intervalosjornada: {},
      antiguedad: null,
      jornada: null,
      periodos: {}
    },

    jornadas: [
      { id: 1, name: "Jornada completa (35/40h)", grupo: "grupoA", periodos: ["INV1", "VERANO", "INV2"] },
      { id: 2, name: "Apoyos", grupo: "grupoA", periodos: ["INV1", "VERANO", "INV2"] },
      { id: 3, name: "2FS (Sábados, domingos y festivos)", grupo: "grupoC", periodos: ["INV1", "VERANO", "INV2"] },
      { id: 4, name: "1FS (Domingos y festivos)", grupo: "grupoB", periodos: ["INV1", "VERANO", "INV2"] }
    ],

    respuestas: {
      antiguedad: { PreguntasCuestionarioId: null, Codigo: 'Q_ANTIGUEDAD' },
      tipoJornada: { PreguntasCuestionarioId: null, Codigo: 'Q_TIPO_JORNADA' },
      inv1_opc1: { PreguntasCuestionarioId: null, Codigo: 'Q_INV1_OPC1' },
      inv1_opc2: { PreguntasCuestionarioId: null, Codigo: 'Q_INV1_OPC2' },
      verano_opc1: { PreguntasCuestionarioId: null, Codigo: 'Q_VERANO_OPC1' },
      verano_opc2: { PreguntasCuestionarioId: null, Codigo: 'Q_VERANO_OPC2' },
      inv2_opc1: { PreguntasCuestionarioId: null, Codigo: 'Q_INV2_OPC1' },
      inv2_opc2: { PreguntasCuestionarioId: null, Codigo: 'Q_INV2_OPC2' }
    }
  }),

  methods: {
    // --- Utilidades de periodos ---
    toLabel(value) {
      const [ini, fin] = value.split('_');
      const f = (d) => { const [y, m, dd] = d.split('-'); return `${dd}/${m}/${y}`; };
      return `${f(ini)} – ${f(fin)}`;
    },
    itemsPeriodos(key) {
      return (this.catalogo[key] || []).map(v => ({ value: v, label: this.toLabel(v) }));
    },
    itemsPeriodosOpc2(key, opc1) {
      return this.itemsPeriodos(key).filter(p => p.value !== opc1);
    },

    resolverPreguntaId(codigo) {
      const lista = this.cuestionario.PreguntasCuestionario || [];

      const mapa = {
        Q_ANTIGUEDAD: ["Antiguedad", "Antigüedad +1 año"],
        Q_TIPO_JORNADA: ["Tipo de Jornada"],
        Q_INV1_OPC1: ["Invierno Opción 1"],
        Q_INV1_OPC2: ["Invierno Opción 2"],
        Q_VERANO_OPC1: ["Verano Opción 1"],
        Q_VERANO_OPC2: ["Verano Opción 2"],
        Q_INV2_OPC1: ["Invierno 2 Opción 1"],
        Q_INV2_OPC2: ["Invierno 2 Opción 2"],
        Q_OBSERVACIONES: ["Observaciones"]
      };

      const posiblesNombres = mapa[codigo] || [];
      const encontrada = lista.find(p =>
        posiblesNombres.some(nombre =>
          p.Titulo?.toLowerCase().includes(nombre.toLowerCase()) ||
          p.Descripcion?.toLowerCase().includes(nombre.toLowerCase())
        )
      );

      return encontrada ? encontrada.PreguntasCuestionarioId : null;
    },

    onjornadaChange() {
      const jornada = this.jornadas.find(t => t.id === this.respuesta.jornada);
      this.periodos = jornada ? jornada.periodos : [];
      this.intervalosjornada = jornada ? intervalosGrupos[jornada.grupo] : {};

      this.respuesta.periodos = this.periodos.reduce((acc, p) => {
        acc[p] = { vacacion1: null, vacacion2: null, mostrarSegundaOpcion: false };
        return acc;
      }, {});
    },
    onPrimeraOpcionChange(periodo) {
      const hasFirst = !!this.respuesta.periodos[periodo].vacacion1;
      this.respuesta.periodos[periodo].mostrarSegundaOpcion = hasFirst;
      if (!hasFirst) this.respuesta.periodos[periodo].vacacion2 = null;
    },


    validar() {
      if (!this.esEmpleado) {
        alert('Debes iniciar sesión con tu usuario personal.');
        this.$router.push('/');
        return false;
      }

      if (!this.respuesta.jornada) {
        alert("Selecciona un jornada");
        return false;
      }

      for (let periodo of this.periodos) {
        const r = this.respuesta.periodos[periodo];
        if (!r.vacacion1 || !r.vacacion2) {
          alert(`Debes pedir todos los periodos, (${periodo}) sin completar`);
          return false;
        }
      }
      return true;
    },

    // Carga inicial
    async getDataFromApi() {
      this.loading = true;
      try {
        const controllerParameters = {
          Titulo: 'CUESTIONARIO VACACIONES MM',
          PerId: this.per.PerId
        };

        const AuthToken = localStorage.getItem('token');
        const { data } = await axios.post(
          this.urlRaiz + "/api/cuestionario/get",
          JSON.stringify(controllerParameters),
          { headers: { "content-type": "application/json", "Authorization": AuthToken } }
        );

        this.cuestionario = data.Cuestionario || {};

        Object.values(this.respuestas).forEach(r => {
          r.PreguntasCuestionarioId = this.resolverPreguntaId(r.Codigo);
        });

      } catch (err) {
        console.error(err);
        alert("Error al cargar el cuestionario");
      } finally {
        this.loading = false;
      }
    },

    async onClickSaveData() {
      if (!this.validar()) return;

      try {
        this.loading = true;

        const respuestas = [];

        // Antigüedad
        respuestas.push({
          PreguntasCuestionarioId: this.respuestas.antiguedad.PreguntasCuestionarioId,
          respuestaUsuario: this.respuesta.antiguedad
        });

        // Tipo de jornada
        const jornadaSel = this.jornadas.find(t => t.id === this.respuesta.jornada);
        respuestas.push({
          PreguntasCuestionarioId: this.respuestas.tipoJornada.PreguntasCuestionarioId,
          respuestaUsuario: jornadaSel ? jornadaSel.name : ""
        });

        //  Vacaciones por periodo (siempre 6 respuestas, aunque el jornada no tenga todos los periodos)
        const periodosEsperados = ["INV1", "VERANO", "INV2"];

        for (let periodo of periodosEsperados) {
          const r = this.respuesta.periodos?.[periodo] || {}; // Lo que haya seleccionado el usuario
          const codBase = periodo.toLowerCase();

          // Primera opción
          const key1 = `${codBase}_opc1`;
          respuestas.push({
            PreguntasCuestionarioId: this.respuestas[key1]?.PreguntasCuestionarioId,
            respuestaUsuario: r.vacacion1 || ""
          });

          // Segunda opción
          const key2 = `${codBase}_opc2`;
          respuestas.push({
            PreguntasCuestionarioId: this.respuestas[key2]?.PreguntasCuestionarioId,
            respuestaUsuario: r.vacacion2 || ""
          });
        }

        // Observaciones (opcional)
        if (this.observaciones && this.observaciones.trim() !== "") {
          const idObs = this.resolverPreguntaId("Q_OBSERVACIONES");
          if (idObs) {
            respuestas.push({
              PreguntasCuestionarioId: idObs,
              respuestaUsuario: this.observaciones
            });
          }
        }

        // construir payload final
        const payload = {
          CuestionarioId: this.cuestionario?.CuestionarioId,
          PerId: this.perId,
          DirId: 0,
          Respuestas: respuestas
        };

        // Autenticación
        const AuthToken = localStorage.getItem("token");

        // Enviar al backend
        const { data } = await axios.post(
          this.urlRaiz + "/api/cuestionario/respuesta/save",
          payload,
          { headers: { "content-type": "application/json", Authorization: AuthToken } }
        );

        // Respuesta OK
        if (data?.Success) {
          alert("Guardado correctamente. En caso de querer realizar alguna modificación tendrás que realizar una solicitud completa de nuevo.");
          this.$router.push("/");
        } else {
          alert(data?.Message || "No se ha podido guardar. Ponte en contacto con Recursos Humanos.");
        }

      } catch (e) {
        console.error(e);
        alert("Error al guardar.");
      } finally {
        this.loading = false;
      }
    },

  },

  mounted() {
    this.getDataFromApi();
  }
};
</script>
